import { createXhrRequester as p } from "./help-center-articles-search48.js";
import { createFallbackableCache as y, createTransporter as P, getAlgoliaAgent as A, shuffle as C, createAuth as b, createBrowserLocalStorageCache as S, createMemoryCache as q, createNullLogger as v } from "./help-center-articles-search49.js";
var w = "5.37.0";
function x(r) {
  return [
    {
      url: `${r}-dsn.algolia.net`,
      accept: "read",
      protocol: "https"
    },
    {
      url: `${r}.algolia.net`,
      accept: "write",
      protocol: "https"
    }
  ].concat(
    C([
      {
        url: `${r}-1.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${r}-2.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${r}-3.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      }
    ])
  );
}
function H({
  appId: r,
  apiKey: n,
  authMode: s,
  algoliaAgents: f,
  ...u
}) {
  const g = b(r, n, s), a = P({
    hosts: x(r),
    ...u,
    algoliaAgent: A({
      algoliaAgents: f,
      client: "Lite",
      version: w
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...g.headers(),
      ...u.baseHeaders
    },
    baseQueryParameters: {
      ...g.queryParameters(),
      ...u.baseQueryParameters
    }
  });
  return {
    transporter: a,
    /**
     * The `appId` currently in use.
     */
    appId: r,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: n,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([a.requestsCache.clear(), a.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return a.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, t) {
      a.algoliaAgent.add({ segment: e, version: t });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !s || s === "WithinHeaders" ? a.baseHeaders["x-algolia-api-key"] = e : a.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia records (hits) and not facets.
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `hits` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `hits`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchForHits(e, t) {
      return this.search(e, t);
    },
    /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia facets and not records (hits).
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `facets` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `facets`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchForFacets(e, t) {
      return this.search(e, t);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: t, body: o }, l) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const i = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: t || {},
        headers: {},
        data: o || {}
      };
      return a.request(i, l);
    },
    /**
     * Retrieves recommendations from selected AI models.
     *
     * Required API Key ACLs:
     *  - search
     * @param getRecommendationsParams - The getRecommendationsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRecommendations(e, t) {
      if (e && Array.isArray(e) && (e = {
        requests: e
      }), !e)
        throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
      if (!e.requests)
        throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
      const c = {
        method: "POST",
        path: "/1/indexes/*/recommendations",
        queryParameters: {},
        headers: {},
        data: e,
        useReadTransporter: !0,
        cacheable: !0
      };
      return a.request(c, t);
    },
    /**
     * Sends multiple search requests to one or more indices.  This can be useful in these cases:  - Different indices for different purposes, such as, one index for products, another one for marketing content. - Multiple searches to the same index—for example, with different filters.  Use the helper `searchForHits` or `searchForFacets` to get the results in a more convenient format, if you already know the return type you want.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchMethodParams - Muli-search request body. Results are returned in the same order as the requests.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    search(e, t) {
      if (e && Array.isArray(e) && (e = {
        requests: e.map(({ params: i, ...h }) => h.type === "facet" ? {
          ...h,
          ...i,
          type: "facet"
        } : {
          ...h,
          ...i,
          facet: void 0,
          maxFacetHits: void 0,
          facetQuery: void 0
        })
      }), !e)
        throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
      if (!e.requests)
        throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
      const c = {
        method: "POST",
        path: "/1/indexes/*/queries",
        queryParameters: {},
        headers: {},
        data: e,
        useReadTransporter: !0,
        cacheable: !0
      };
      return a.request(c, t);
    }
  };
}
function E(r, n, s) {
  return H({
    appId: r,
    apiKey: n,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: v(),
    requester: p(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: q(),
    requestsCache: q({ serializable: !1 }),
    hostsCache: y({
      caches: [S({ key: `${w}-${r}` }), q()]
    }),
    ...s
  });
}
export {
  w as apiClientVersion,
  E as liteClient
};
//# sourceMappingURL=help-center-articles-search44.js.map
